import React from "react"
import "./styles.scss"
import TLink from "../../transitions/TLink"
import Img from "gatsby-image"

const Article = ({
  link,
  category,
  date,
  timeToRead,
  title,
  excerpt,
  image,
  delay,
}) => {
  const shapedDate = date ? new Date(date) : ""
  return (
    <TLink to={link}>
      <div
        style={
          delay
            ? {
                animationDelay: `${delay / 10}s`,
              }
            : undefined
        }
        className="article"
      >
        <div className="article__imageWrapper">
          <Img alt={title} className="article__image" fluid={image} />
          <div className="article__overlay">
            <span>Read More</span>
          </div>
        </div>
        <div className="article__data">
          <span>{category?.title || category?.Title}</span>
          {shapedDate && (
            <span>
              {" "}
              &#183; {shapedDate.toLocaleString("en-GB", {
                month: "long",
              })}{" "}
              {shapedDate.getFullYear()}
            </span>
          )}
        </div>
        <h3 className="article__title">{title}</h3>
        <p className="article__excerpt">{excerpt}</p>
        <span className="article__time">{timeToRead} min read</span>
      </div>
    </TLink>
  )
}

export default Article
